import { Component, OnInit } from "@angular/core";
import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { TokenizedConfigTemplate, UserInputSection, AssetConfigIdentifiers } from "src/app/config-template";

@Component({
	selector: "app-templated-config",
	templateUrl: "./templated-config.component.html",
	styleUrls: ["./templated-config.component.scss"]
})
export class TemplatedConfigComponent implements OnInit {
	public templates: APIResults.ConfigTemplate[];
	public organizations: APIResults.Organization[];
	public selectedTemplate: APIResults.ConfigTemplate;
	public rawTemplate: string;
	public template: TokenizedConfigTemplate;
	public userinputgroups: UserInputSection[];
	public assetconfig: string;
	public selectedOrganization: APIResults.Organization;
	public ident: AssetConfigIdentifiers;

	public loaderrormessage = "";

	constructor(public api: ApiService) { }

	ngOnInit() {
		this.UpdateTemplates();
		this.UpdateOrganizations();
	}

	async UpdateTemplates() {
		const templates = await this.api.GetAllTemplates();
		this.templates = templates;
	}
	async UpdateOrganizations() {
		const organizations = await this.api.GetOrganizations();
		this.organizations = organizations;
	}

	async templateChange(template: APIResults.ConfigTemplate) {
		this.rawTemplate = undefined;
		this.template = undefined;
		this.userinputgroups = undefined;
		this.assetconfig = undefined;
		this.selectedOrganization = undefined;
		this.ident = undefined;

		this.loaderrormessage = "";
		try {
			try {
				this.rawTemplate = await this.api.GetTemplateContent(template.template_id);
			} catch (apierr) {
				try {
					// Since result is text, error doesn't get parsed
					const parsed = JSON.parse(apierr.error);
					apierr.error = parsed;
					throw apierr;
				} catch (parseerr) {
					throw apierr;
				}
			}
			this.template = new TokenizedConfigTemplate(this.rawTemplate);
			this.userinputgroups = this.template.GetGroupedUserInputs();
		} catch (err) {
			const message = err.error ? err.error.message : err.message;
			this.loaderrormessage = "Error: " + message;
		}
	}

	public GenerateConfig() {
		try {
			this.assetconfig = this.template.Populate();
			this.ident = this.template.GetIdentifiers();
		} catch (err) {
			// let message = err.error ? err.error.message : err.message;
			if (err.token) {
				err.message += " for field: " + err.token.description;
			}
			throw err;
		}
	}

	public GoBack() {
		this.assetconfig = undefined;
		this.ident = undefined;
	}

	public async SaveConfig() {
		try {
			await this.api.AddConfig(this.selectedOrganization.organization_id, this.assetconfig);
		} catch (err) {
			// let message = err.error ? err.error.message : err.message;
			if (err.message.startsWith("ER_DUP_ENTRY")) {
				err.message = "A configuration with the name " + this.ident.type + " already exists";
			}
			throw err;
		}
	}

}
